/**
 * Safely extracts a displayable error message from various error formats.
 * Prevents React from crashing when attempting to render an object as a child.
 */
export const getErrorMessage = (error: any): string => {
  if (error === null || error === undefined) {
    return '';
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  if (typeof error === 'object') {
    // Handle API error objects { message, statusCode }
    if (error.message && typeof error.message === 'string') {
      return error.message;
    }
    
    // Handle standard Error objects
    if (error instanceof Error) {
      return error.message;
    }
    
    // Fallback for other objects
    try {
      return JSON.stringify(error);
    } catch {
      return 'An unexpected error occurred';
    }
  }
  
  return String(error);
};
